module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 71.25748502994011,
						"dataLabels": {
							"enabled": true,
							"format": "357",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.477045908183634,
						"dataLabels": {
							"enabled": true,
							"format": "308",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.48502994011976,
						"dataLabels": {
							"enabled": true,
							"format": "288",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 49.700598802395206,
						"dataLabels": {
							"enabled": true,
							"format": "249",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 33.13373253493014,
						"dataLabels": {
							"enabled": true,
							"format": "166",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.66984884645983,
						"dataLabels": {
							"enabled": true,
							"format": "1190",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.47494033412887,
						"dataLabels": {
							"enabled": true,
							"format": "999",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.22434367541766,
						"dataLabels": {
							"enabled": true,
							"format": "933",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.47334924423231,
						"dataLabels": {
							"enabled": true,
							"format": "823",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.6642800318218,
						"dataLabels": {
							"enabled": true,
							"format": "574",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.49497367161321,
						"dataLabels": {
							"enabled": true,
							"format": "1974",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.26711345141216,
						"dataLabels": {
							"enabled": true,
							"format": "1635",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.94830062230733,
						"dataLabels": {
							"enabled": true,
							"format": "1503",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.05505026328386,
						"dataLabels": {
							"enabled": true,
							"format": "1359",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 44.23168980373384,
						"dataLabels": {
							"enabled": true,
							"format": "924",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.26165841955316,
						"dataLabels": {
							"enabled": true,
							"format": "6353",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.26795621532465,
						"dataLabels": {
							"enabled": true,
							"format": "5153",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.24471434997751,
						"dataLabels": {
							"enabled": true,
							"format": "4818",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.13615234667866,
						"dataLabels": {
							"enabled": true,
							"format": "4544",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50.562303193882144,
						"dataLabels": {
							"enabled": true,
							"format": "3372",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -28.742514970059887,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.725490196078427,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.493506493506496,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.541666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.330151153540175,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.050420168067227,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.6066066066066025,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.789924973204712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -30.255164034021874,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.505026328386786,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.173252279635253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.073394495412845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.58083832335329,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -32.00883002207505,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.738341580446848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.88871399338895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.501067339413935,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.687007056870074,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25.792253521126764,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=501"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1257"
			},
			{
				"x": 15,
				"text": "40–49<br>n=2089"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6669"
			}
		],
		"dataTable": {
			"< 30": [
				501,
				357,
				308,
				288,
				249,
				166
			],
			"30–39": [
				1257,
				1190,
				999,
				933,
				823,
				574
			],
			"40–49": [
				2089,
				1974,
				1635,
				1503,
				1359,
				924
			],
			"≥ 50": [
				6669,
				6353,
				5153,
				4818,
				4544,
				3372
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 168
// module chunks = 0